export const PROJECT_PROGRESSION_COMPONENTS = {
  HEADER: 'HEADER',
  PROGRESSION_OVER_TIME: 'PROGRESSION_OVER_TIME',
  INSIGHTS: 'INSIGHTS',
  PROGRESSION_TABLE: 'PROGRESSION_TABLE'
};
